if($('header#header').length){
    $('.navigationActions').append('<li><a href="/doprava-a-platba/"><span>Doprava a platba</span></a></li><li><a href="/kontakty/"><span>Kontakty</span></a></li>')
    $('.has-third-level').each(function(){
        if($(this).find('li').length>5){
            $(this).find('.menu-level-3').append('<li class="display-more"><a href="'+$(this).find('.menu-image').attr('href')+'">Další kategorie</a></li>')
        }
    })
}